import { useEffect, useRef, useState } from "react";

const CHAR_INTERVAL_MS = 18;

export const useTypingText = (
  text: string,
  isActive: boolean,
  onComplete?: () => void
) => {
  const [displayed, setDisplayed] = useState("");
  const indexRef = useRef(0);
  const onCompleteRef = useRef(onComplete);
  const startTimeRef = useRef(0);

  useEffect(() => {
    onCompleteRef.current = onComplete;
  });

  useEffect(() => {
    if (!isActive) return;
    indexRef.current = 0;
    startTimeRef.current = Date.now();

    const advance = () => {
      const elapsed = Date.now() - startTimeRef.current;
      const target = Math.min(
        Math.floor(elapsed / CHAR_INTERVAL_MS),
        text.length
      );
      if (target > indexRef.current) {
        indexRef.current = target;
        setDisplayed(text.slice(0, target));
      }
      if (indexRef.current >= text.length) {
        clearInterval(iv);
        onCompleteRef.current?.();
      }
    };

    const iv = setInterval(advance, CHAR_INTERVAL_MS);

    // Catch up when the tab regains visibility after being throttled
    const onVisible = () => {
      if (document.visibilityState === "visible") {
        advance();
      }
    };
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      clearInterval(iv);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [isActive, text]);

  return displayed;
};
